import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) {
      setIsMediaOpen(false);
    }
  };

  const handleMediaClick = (e) => {
    if (window.innerWidth <= 1400) {
      e.preventDefault();
      setIsMediaOpen(!isMediaOpen);
    } else {
      navigate('/media');
    }
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
    setIsMediaOpen(false);
  };

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === 'Escape') {
        setIsMenuOpen(false);
        setIsMediaOpen(false);
        buttonRef.current && buttonRef.current.focus();
      }
    }
    function onClickOutside(e) {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target)) {
        setIsMenuOpen(false);
        setIsMediaOpen(false);
      }
    }
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onClickOutside);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <nav className="navbar" role="navigation" aria-label="Main Navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/">Harris County Historical Society</Link>
        </div>
        <button
          className="hamburger"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          aria-label="Toggle menu"
          ref={buttonRef}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul
          id="primary-navigation"
          className={`nav-links ${isMenuOpen ? 'active' : ''}`}
          role="menubar"
          ref={menuRef}
        >
          <li role="none"><button className={`nav-button ${isActive('/') ? 'active' : ''}`} role="menuitem" onClick={() => { handleLinkClick(); navigate('/'); }}>Home</button></li>
          <li role="none"><button className={`nav-button ${isActive('/about') ? 'active' : ''}`} role="menuitem" onClick={() => { handleLinkClick(); navigate('/about'); }}>About</button></li>
          <li className={`nav-dropdown ${isMediaOpen ? 'open' : ''}`} role="none">
            <button className={`nav-button with-dropdown ${isActive('/media') ? 'active' : ''}`} aria-haspopup="true" aria-expanded={isMediaOpen} onClick={handleMediaClick}>
              Media
              <span className="dropdown-arrow">▼</span>
            </button>
            <ul className="dropdown-content" role="menu">
              <li role="none"><button className="nav-button" role="menuitem" onClick={() => { handleLinkClick(); navigate('/media/publications'); }}>Publications</button></li>
              <li role="none"><button className="nav-button" role="menuitem" onClick={() => { handleLinkClick(); navigate('/media/videos'); }}>Videos</button></li>
              <li role="none"><button className="nav-button" role="menuitem" onClick={() => { handleLinkClick(); navigate('/media/markers'); }}>Historical Markers</button></li>
            </ul>
          </li>
          <li role="none"><button className={`nav-button ${isActive('/events') ? 'active' : ''}`} role="menuitem" onClick={() => { handleLinkClick(); navigate('/events'); }}>Events</button></li>
          <li role="none"><button className={`nav-button ${isActive('/support') ? 'active' : ''}`} role="menuitem" onClick={() => { handleLinkClick(); navigate('/support'); }}>Membership</button></li>
          <li role="none"><button className={`nav-button ${isActive('/contact') ? 'active' : ''}`} role="menuitem" onClick={() => { handleLinkClick(); navigate('/contact'); }}>Contact</button></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
